import type { SelectraDetailsFeature } from 'src/types/Selectra';
import { formatSelectraPrice } from 'src/helpers/selectra_tariff_helpers';

export const resolveSelectraOfferName = (
	localizedNames: Record<string, string> | null | undefined,
	countryCode: string,
): string => {
	if (!localizedNames) return '';

	const localizedCountryName = localizedNames[countryCode]?.trim();
	if (localizedCountryName) return localizedCountryName;

	for (const name of Object.values(localizedNames)) {
		const trimmedName = name.trim();
		if (trimmedName) return trimmedName;
	}

	return '';
};

const hasDisplayableSelectraFeatureName = (feature: SelectraDetailsFeature): boolean =>
	typeof feature.name === 'string' && Boolean(feature.name.trim());

export const getSortedSelectraSupplyFeatures = (
	features: SelectraDetailsFeature[],
): SelectraDetailsFeature[] =>
	features
		.map((feature, index) => ({ feature, index }))
		.filter(({ feature }) => hasDisplayableSelectraFeatureName(feature))
		.sort((a, b) => a.feature.display_order - b.feature.display_order || a.index - b.index)
		.map(({ feature }) => feature);

export const formatSelectraFeatureValue = (value: number, unit: string | null | undefined): string => {
	const formattedValue = formatSelectraPrice(value);
	const formattedUnit = typeof unit === 'string' ? unit.trim() : '';

	return formattedUnit ? `${formattedValue} ${formattedUnit}` : formattedValue;
};

export const getUniqueNonEmptyValues = (values: string[]): string[] => {
	const uniqueValues: string[] = [];

	for (const value of values) {
		const trimmedValue = value.trim();
		if (trimmedValue && !uniqueValues.includes(trimmedValue)) {
			uniqueValues.push(trimmedValue);
		}
	}

	return uniqueValues;
};
